<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Goodwill Abacus Form</title>
  <style>
    body {
      font-family: Arial, sans-serif;
    }

    .container {
      background-color: #e6e6e6;
      padding: 9px;
      border-radius: 10px;
      max-width: 700px;
      margin: 0 auto;
    }

    /* .blue-box {
      background-color: #032152;
      color: white;
      font-weight: bold;
      font-size: 22px;
      padding: 15px;
      margin-bottom: 20px;
      text-align: left;
    } */

    .form-grid {
      display: grid;
      grid-template-columns: 130px 261px 133px 264px;
      gap: 15px;
      align-items: center;
      margin-bottom: 20px;
    }

    label {
      font-weight: bold;
    }

    input[type="text"],
    input[type="number"] {
      width: 100%;
      padding: 8px;
      border: 1px solid #ced4da;
      border-radius: 5px;
    }

    .unit-selection-inline {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .results-header {
      text-align: left;
      font-weight: bold;
      font-size: 20px;
      margin-top: 30px;
      margin-left: 6.5cm; /* Adjusted for positioning */
    }

    table {
      width: 60%;
      border-collapse: collapse;
      margin: 20px auto;
      border: 4px double black;
    }

    td, th {
      border: 4px double black;
      padding: 10px;
      text-align: center;
      background-color: #d9d9d9; /* Background color for table cells */
    }

    .status-box {
      background-color: green;
      width: 50px;
      height: 20px;
      margin: auto;
      padding: 5px;
    }

    .btn-container {
      display: flex;
      justify-content: center;
      margin-top: 38px;
      margin-left: 18cm;
    }

    .dialog-button {
      width: 12px; /* Set the width of the button to 12px */
      padding: 6px 12px;  /* Adjusted padding */
      background-color: #007bff;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }

    .dialog-button:hover {
      background-color: #0056b3;
    }

    /* Rectangle box styles */
    .rectangle-box {
      border: 2px solid #bfbfbf;
      padding: 22px;
      margin: -30px auto;
      width: 90%;  /* Adjust width as needed */
      max-width: 958px;
      border-radius: 10px;
    }
    
    
  </style>
</head>
<body>
  <ngx-spinner></ngx-spinner>

  <div *ngIf="isTokenValidated">
    <header>
      <div class="blue-box">Goodwill Abacus Calculator</div>
    </header>

    <div class="container">
      <h1 style="text-align: center; font-size: 16px; font-weight: bold;"><BR></h1> 

      <!-- Rectangle Box Start -->
      
        <form (ngSubmit)="onSubmit()">
          <div class="rectangle-box">
          <div class="form-grid">
            <!-- VIN Field -->
            <label for="vin" translate>dimbo.i18n.header.vin</label>
            <input type="text" id="vin" [(ngModel)]="vin" name="vin" [readonly]="vinReadOnly" placeholder="{{ 'dimbo.i18n.placeholder.vin' | translate }}" />

            <!-- Brand Label -->
            <label for="brand" translate>{{ 'dimbo.i18n.header.brand' | translate }}</label>
            <span>{{ brand }}</span> <!-- Display brand label -->

            <!-- Part Reference -->
            <label for="partReference" translate>dimbo.i18n.header.partReference</label>
            <input type="text" id="partReference" [(ngModel)]="partReference" name="partReference" placeholder="{{ 'dimbo.i18n.placeholder.partReference' | translate }}" required />

            <!-- Current Mileage with Inline Radio Buttons -->
            <label for="currentMileage" translate>dimbo.i18n.header.currentMileage</label>
            <div class="unit-selection-inline">
              <input type="text" id="currentMileage" [(ngModel)]="currentMileage" name="currentMileage" placeholder="{{ 'dimbo.i18n.placeholder.currentMileage' | translate }}" required />
              <label>
                <input type="radio" name="unit" [(ngModel)]="unit" [value]="'km'" />
                <span translate>dimbo.i18n.unit.km</span>
              </label>
              <label>
                <input type="radio" name="unit" [(ngModel)]="unit" [value]="'miles'" />
                <span translate>dimbo.i18n.unit.miles</span>
              </label>
            </div>
          </div>
            <div class="btn-container">
            <input class="dialog-button" type="button" (click)="allowAddService()" [value]="oktranlation" />
          </div>
             </div>
      <!-- Rectangle Box End -->
      <BR>

          <!-- <div class="btn-container">
            <input class="dialog-button" type="button" (click)="allowAddService()" [value]="oktranlation" />
          </div> -->
        </form>
     

      <!-- Results Section -->
      <div class="results-header">Goodwill Abacus Results</div>
      <table>
        <tr>
          <td style="text-align: left;">Status Request</td>
          <td>
            <div class="status-box"></div>
          </td>
          <td style="text-align: left;">Approval Status</td>
          <td></td>
        </tr>
        <tr>
          <td style="text-align: left;">% Labour Acknowledged</td>
          <td>50%</td>
          <td style="text-align: left;">% Material Acknowledged</td>
          <td>50%</td>
        </tr>
      </table>
    </div>
  </div>
</body>
</html>
